import { ICommand } from 'core-ts-types';
import { IResourceCategoriesQueryResult } from './../../queries/resource_categories_query';

export class ResourceTabsController {
  private selected: number;
  private categories: IResourceCategoriesQueryResult[];

  constructor(private selectResourceCategoryCommand: ICommand) {}

  getBadgeTheme(isSelected: boolean): string {
    return isSelected ? 'gray-dark' : 'gray-light';
  }

  resourceTabSelectionChanged($event: CustomEvent) {
    const firstIndex = 0;
    const selectedIndex = $event.detail.value === null ? firstIndex : $event.detail.value;
    return this.selectResourceCategoryCommand(this.categories[selectedIndex]);
  }
}

angular
  .module('capability-ng-resources')
  .controller('ngResourceTabsController', ResourceTabsController)
  .component('resourceTabs', {
    templateUrl: 'lib/resources/components/resource_tabs/resource_tabs.html',
    controller: 'ngResourceTabsController',
    controllerAs: '$ctrl',
    bindings: {
      categories: '<'
    }
  });



// WEBPACK FOOTER //
// ./app/lib/resources/components/resource_tabs/resource_tabs.ts